import type { StoryblokRichTextNode } from "@storyblok/react";
import type { FC, PropsWithChildren, ReactElement } from "react";
import RichText from "../../../general/RichText";
import * as s from "./Content.module.scss";

type ContentProps = PropsWithChildren<{
	content: string | StoryblokRichTextNode<ReactElement>;
}>;

const Content: FC<ContentProps> = ({ children, content }) => {
	return (
		<section className={s.content}>
			<RichText content={content} />

			<div>{children}</div>
		</section>
	);
};

export default Content;
